import { render, staticRenderFns } from "./modalViewOrder.vue?vue&type=template&id=a5df560e&"
import script from "./modalViewOrder.vue?vue&type=script&lang=js&"
export * from "./modalViewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports